// Gift Card Dynamic Variant Handler
(function() {
  'use strict';
  
  let productData = null;
  
  // Function to get product data
  function getProductData() {
    const productFormComponent = document.querySelector('product-form-component');
    if (!productFormComponent) return null;
    
    const productUrl = productFormComponent.getAttribute('data-product-url');
    if (!productUrl) return null;
    
    // Fetch product JSON
    return fetch(productUrl + '.js')
      .then(response => response.json())
      .then(data => {
        productData = data;
        return data;
      })
      .catch(error => {
        console.error('Error fetching product data:', error);
        return null;
      });
  }
  
  // Function to check if current variant title contains "Yes"
  function checkIfVariantIsYes(variantId) {
    if (!productData || !productData.variants) {
      console.log('Product data not available');
      return false;
    }
    
    const variant = productData.variants.find(v => v.id == variantId);
    if (!variant) {
      console.log('Variant not found:', variantId);
      return false;
    }
    
    console.log('Current variant title:', variant.title);
    
    // Check if variant title contains "Yes" (case insensitive) or "نعم" (Arabic for yes)
    const title = variant.title.toLowerCase();
    return title.includes('yes') || variant.title.includes('نعم');
  }
  
  // Function to show/hide gift card fields
  function toggleGiftCardFields(variantId) {
    const giftCardContainer = document.querySelector('[data-gift-card-fields]');
    
    if (!giftCardContainer) {
      console.log('Gift card container not found');
      return;
    }
    
    const isYesVariant = checkIfVariantIsYes(variantId);
    
    if (isYesVariant) {
      console.log('Showing gift card fields - variant is Yes');
      giftCardContainer.style.display = 'block';
      
      // Initialize the textarea functionality
      if (window.initializeGiftCardMessage) {
        setTimeout(window.initializeGiftCardMessage, 100);
      }
    } else {
      console.log('Hiding gift card fields - variant is not Yes');
      giftCardContainer.style.display = 'none';
      
      // Clear the textarea value
      const textarea = document.getElementById('gift-card-message');
      if (textarea) {
        textarea.value = '';
        const charCounter = document.getElementById('char-counter');
        if (charCounter) charCounter.textContent = '0';
      }
    }
  }
  
  // Function to handle variant change
  function handleVariantChange() {
    const variantInput = document.querySelector('input[ref="variantId"]');
    if (!variantInput) {
      console.log('Variant input not found');
      return;
    }
    
    const variantId = variantInput.value;
    console.log('Variant changed to:', variantId);
    
    toggleGiftCardFields(variantId);
  }
  
  // Initialize on page load
  function init() {
    console.log('Initializing gift card dynamic handler...');
    
    // Get product data first
    getProductData().then(() => {
      // Check initial variant
      handleVariantChange();
      
      // Watch for variant changes
      const variantInput = document.querySelector('input[ref="variantId"]');
      if (variantInput) {
        // Use MutationObserver to watch for value changes
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              console.log('Variant input value changed via attribute');
              handleVariantChange();
            }
          });
        });
        
        observer.observe(variantInput, {
          attributes: true,
          attributeFilter: ['value']
        });
        
        // Also listen for input events (some themes use this)
        variantInput.addEventListener('change', function() {
          console.log('Variant input changed via event');
          handleVariantChange();
        });
      }
      
      // Listen for form submissions to update the hidden input
      const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
      if (productForm) {
        // Watch all inputs that might change the variant
        const allInputs = productForm.querySelectorAll('select, input[type="radio"]');
        allInputs.forEach(input => {
          input.addEventListener('change', function() {
            console.log('Form input changed');
            // Give time for variantId to update
            setTimeout(handleVariantChange, 100);
          });
        });
      }
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();